import { AdminPortal } from '@frontegg/react'
import { FunctionComponent } from 'react'
import { MenuItem } from '@mui/material'

interface Props {
  handleClose: Function
}
const ShowAdminMenuItem: FunctionComponent<Props> = ({ handleClose }) => {
  const showAdmin = () => {
    handleClose()
    AdminPortal.show()
  }

  return (
    <MenuItem onClick={showAdmin} data-testid="show-admin" sx={{ pt: 2 }}>
      Developer Console
    </MenuItem>
  )
}

export default ShowAdminMenuItem
